<template>
    <div id="app">
        <nav class="navbar navbar-expand-sm bg-light" id="nav">
            <!-- Links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <router-link to="/" class="nav-link">{{ $t('Employee Report')}}</router-link>
                </li>
                <li class="nav-item d-none">
                    <router-link to="/employee" class="nav-link">{{ $t('Employee Info')}}</router-link>
                </li>
            </ul>
            <ul class="nav  ml-auto">
                <li>
                    <select v-model="$i18n.locale" @change="set_language($event.target.value)">
                        <option v-for="locale in $i18n.availableLocales" :key="locale">{{ locale }}</option>
                    </select>
                </li>
            </ul>
        </nav>
        <router-view />
        <flash class="alert alert-flash"></flash>
        <back-to-top bottom="30px" right="30px">
            <button type="button" class="btn btn-info btn-to-top"><i class="fas fa-chevron-up"></i></button>
        </back-to-top>
    </div>
</template>
<script>
export default {
    methods: {
        set_language(lang){
            moment.locale(lang); 
        }
    }
}
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
